import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/app/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/app/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/app/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/app/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/app/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/app/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/app/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DataDebugger"] */ "/app/src/components/data-debugger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GtmEventComponent"] */ "/app/src/components/head/gtm-event-component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FecomImage"] */ "/app/src/components/images/fecom-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlternativeProduct"] */ "/app/src/components/products/alternative-product.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetailsAddtoBasket"] */ "/app/src/components/products/product-details-add-to-basket.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/products/product-details-lessons.css");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetailsPrice"] */ "/app/src/components/products/product-details-price.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetailsReviewsAccordion"] */ "/app/src/components/products/product-details-reviews-accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetailsStarRating"] */ "/app/src/components/products/product-details-star-rating.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductImageCarousel"] */ "/app/src/components/products/product-image-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductsILoveButton"] */ "/app/src/components/products/products-i-love-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliTrackingClientWrapped"] */ "/app/src/components/tracking/sli-tracking-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/app/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DropdownMenu","DropdownMenuTrigger","DropdownMenuContent","DropdownMenuItem"] */ "/app/src/components/ui/dropdown-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider","Tooltip","TooltipTrigger","TooltipContent"] */ "/app/src/components/ui/tooltip.tsx");
